var _path, _path2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgLive = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -4 72 72",
    width: "24px",
    height: "24px",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 10.5h-2v-2c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v2H12c-3.3 0-6 2.7-6 6v27.9c0 3.3 2.7 6 6 6h12c0 .1 0 3-2 3-1.1 0-2 .9-2 2s.9 2 2 2h20c1.1 0 2-.9 2-2s-.9-2-2-2c-1.9 0-2-2.7-2-3h12c3.3 0 6-2.7 6-6V16.5c0-3.3-2.7-6-6-6zm-8 0h2v22h-2v-22zm-32 4h28v20c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-20h2c1.1 0 2 .9 2 2v22H10v-22c0-1.1.9-2 2-2zm15.4 39c.4-1 .6-2.1.6-3h8c0 .9.2 2 .6 3h-9.2zm24.6-7H12c-1.1 0-2-.9-2-2v-2h44v2c0 1.1-.9 2-2 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36.5h6c1.1 0 2-.9 2-2v-15c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2zm2-15h2v11h-2v-11zm-15 15h6c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2zm2-9h2v5h-2v-5z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/live.4df52eb7.svg";
export { ForwardRef as ReactComponent };